module.exports = __webpack_public_path__ + "static/media/university-house-l.b5adefda.png";